import script from "./list-service.vue?vue&type=script&setup=true&lang=js"
export * from "./list-service.vue?vue&type=script&setup=true&lang=js"

import "./list-service.vue?vue&type=style&index=0&id=4a998e78&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a998e78"]])

export default __exports__